import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enAuth from './locales/en/auth.json'
import enBed from './locales/en/bed.json'
import enCommon from './locales/en/common.json'
import enDashboard from './locales/en/dashboard.json'
import enDepartment from './locales/en/department.json'
import enEquipment from './locales/en/equipment.json'
import enFloorPlan from './locales/en/floor-plan.json'
import enGateway from './locales/en/gateway.json'
import enNavigation from './locales/en/navigation.json'
import enPatient from './locales/en/patient.json'
import enQuotation from './locales/en/quotation.json'
import enRepairs from './locales/en/repairs.json'
import enRequests from './locales/en/requests.json'
import enScanItems from './locales/en/scan-items.json'
import enUsers from './locales/en/users.json'
import enVendors from './locales/en/vendors.json'
import thAuth from './locales/th/auth.json'
import thBed from './locales/th/bed.json'
import thCommon from './locales/th/common.json'
import thDashboard from './locales/th/dashboard.json'
import thDepartment from './locales/th/department.json'
import thEquipment from './locales/th/equipment.json'
import thFloorPlan from './locales/th/floor-plan.json'
import thGateway from './locales/th/gateway.json'
import thNavigation from './locales/th/navigation.json'
import thPatient from './locales/th/patient.json'
import thQuotation from './locales/th/quotation.json'
import thRepairs from './locales/th/repairs.json'
import thRequests from './locales/th/requests.json'
import thScanItems from './locales/th/scan-items.json'
import thUsers from './locales/th/users.json'
import thVendors from './locales/th/vendors.json'

import { useLanguageStore } from '@/stores/useLanguageStore'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          auth: enAuth,
          bed: enBed,
          common: enCommon,
          dashboard: enDashboard,
          department: enDepartment,
          equipment: enEquipment,
          floorplan: enFloorPlan,
          navigation: enNavigation,
          patient: enPatient,
          quotation: enQuotation,
          repairs: enRepairs,
          requests: enRequests,
          scans: enScanItems,
          gateway: enGateway,
          users: enUsers,
          vendors: enVendors,
        },
      },
      th: {
        translation: {
          auth: thAuth,
          bed: thBed,
          common: thCommon,
          dashboard: thDashboard,
          department: thDepartment,
          equipment: thEquipment,
          floorplan: thFloorPlan,
          navigation: thNavigation,
          patient: thPatient,
          quotation: thQuotation,
          repairs: thRepairs,
          requests: thRequests,
          scans: thScanItems,
          gateway: thGateway,
          users: thUsers,
          vendors: thVendors,
        },
      },
    },

    lng: useLanguageStore.getState().language,
    fallbackLng: 'th',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
